/**
 * @file 消耗总览
 * @author lanistzhang
 */

import _ from 'lodash';
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Button } from '@tencent/spaui';
import Icon from '@tencent/od-icon';

import { DeskAnnouncementContent } from '@/pages/agency/notice/DeskAnnouncement';
import globalStore from '@/stores';

import HomeItem, { HomeRowWrapper } from '../home-item';
import FastEntry, { FastEntryProps } from './fast-entry';

export interface AnnouncementEntryProps {
  fastEntry: FastEntryProps;
  layout?: 'row' | 'column';
}

/**
 * 公告 + 常用入口
 */
const AnnouncementEntry: React.FC<AnnouncementEntryProps> = (props) => {
  const { fastEntry, layout = 'row' } = props;
  const { history } = globalStore;

  const cardComponent = useMemo(() => {
    const size = layout === 'column' ? 'mini' : 'normal';
    return <>
      <HomeItem
        className={classnames({ mini: layout === 'column' })}
        header={(
          <>
            <div className="title">常用入口</div>
            <div className="right">
              <Button
                className="more"
                displayType="link"
                endIcon={<Icon name="right-outlined" />}
                data-report="home-jump-toolbox-more"
                onClick={() => history.push('/agency/manage/toolbox')}
              >
                更多
              </Button>
            </div>
          </>
        )}
      >
        <FastEntry {...fastEntry} size={size} />
      </HomeItem>
      <HomeItem
        className={classnames({ mini: layout === 'column' })}
        header={(
          <>
            <div className="title">公告</div>
            <div className="right">
              <Button
                className="more"
                displayType="link"
                endIcon={<Icon name="right-outlined" />}
                data-report="home-jump-notice-more"
                onClick={() => history.push('/agency/notice')}
              >
                更多
              </Button>
            </div>
          </>
        )}
      >
        <DeskAnnouncementContent size={size} />
      </HomeItem>
    </>;
  }, [layout]);

  if (layout === 'column') {
    return cardComponent;
  }

  return (
    <HomeRowWrapper>
      {cardComponent}
    </HomeRowWrapper>
  );
};

export default AnnouncementEntry;
